import util from '@bmp-vue/core/api/util'

const controller = 'Format'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  ContaPgto: (value) => {
    if (value) {
      const regex = /([0-9]{7})([0-9{1}])/
      const subst = '$1-$2'
      return value.replace(regex, subst)
    } else return ''
  }
})
